module.exports = __webpack_public_path__ + "img/i_c_key_06.a1fd1aff.svg";